// components/FloatingAssistant.jsx
import React, { useEffect, useState } from 'react';
import { Box, IconButton, Tooltip, Fade, Badge } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { BsRobot } from 'react-icons/bs';
import { useChatActive } from '../../hooks/useChatActive';

export function FloatingAssistant() {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const isChatActive = useChatActive();

  useEffect(() => {
    const timeout = setTimeout(() => setShow(true), 1000); // aparece depois de 1s
    return () => clearTimeout(timeout);
  }, []);

  if (!show) return null;

  const tooltipLabel = isChatActive
    ? 'Você tem conversas em aberto no chat. Clique para continuar.'
    : 'Fale com nosso assistente inteligente';

  return (
    <Fade in={show}>
      <Box position="fixed" bottom="24px" right="24px" zIndex={50}>
        <Tooltip label={tooltipLabel} aria-label="Assistente Inteligente" hasArrow placement="left">
          <Box position="relative">
            <IconButton
              icon={<BsRobot />}
              aria-label="Assistente Inteligente"
              colorScheme="blue"
              borderRadius="full"
              size="lg"
              onClick={() => navigate('/chatPro')}
              boxShadow="lg"
            />
            {isChatActive && (
              <Badge
                position="absolute"
                top="-2px"
                right="-2px"
                colorScheme="red"
                borderRadius="full"
                w="12px"
                h="12px"
                p={0}
                border="2px solid white"
              />
            )}
          </Box>
        </Tooltip>
      </Box>
    </Fade>
  );
}
